// Item 252 Phase A — i18next bootstrap. English is the base locale;
// German is the second locale (regulated-EU-customer market). The
// chosen locale persists in localStorage under `orb-locale`, mirroring
// ThemeProvider's `orb-theme` key (see ../theme/ThemeProvider.tsx).

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/common.json';
import de from './locales/de/common.json';

export const STORAGE_KEY = 'orb-locale';
export const SUPPORTED_LOCALES = ['en', 'de'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export function readStoredLocale(): Locale {
  if (typeof globalThis === 'undefined') return 'en';
  const v = globalThis.localStorage.getItem(STORAGE_KEY);
  return v === 'de' ? 'de' : 'en';
}

i18next.use(initReactI18next).init({
  resources: {
    en: { common: en },
    de: { common: de },
  },
  lng: readStoredLocale(),
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
});

export default i18next;
